import { TransactionStatus, } from '@train-protocol/sdk';
export async function getTransaction(provider, txHash) {
    try {
        const { transaction } = await provider.operations.getTransactionWithReceipts({
            transactionId: txHash,
        });
        const status = transaction?.status;
        if (!status)
            return null;
        let mappedStatus;
        switch (status.type) {
            case 'SuccessStatus':
                mappedStatus = TransactionStatus.Confirmed;
                break;
            case 'FailureStatus':
            case 'SqueezedOutStatus':
            case 'PreconfirmationFailureStatus':
                mappedStatus = TransactionStatus.Failed;
                break;
            default:
                mappedStatus = TransactionStatus.Pending;
        }
        return {
            hash: txHash,
            status: mappedStatus,
        };
    }
    catch {
        return null;
    }
}
